"use strict";

exports.__esModule = true;
exports.getSuppliedContextsInElementPath = getSuppliedContextsInElementPath;
var _getWidget = require("./getWidget");
var _getElementsInPath = require("./getElementsInPath");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Find all the contexts that an element path supplies.
 */
function getSuppliedContextsInElementPath(widgets, root, path) {
  var elements = (0, _getElementsInPath.getElementsInPath)(root, path);
  var supplied = [];
  for (var _iterator = _createForOfIteratorHelperLoose(elements), _step; !(_step = _iterator()).done;) {
    var element = _step.value;
    var widget = (0, _getWidget.getWidgetOrThrow)(widgets, element.type);
    for (var _iterator2 = _createForOfIteratorHelperLoose(widget.suppliesContexts), _step2; !(_step2 = _iterator2()).done;) {
      var name = _step2.value;
      if (!supplied.includes(name)) {
        supplied.push(name);
      }
    }
  }
  return supplied;
}